import React from "react";
import ContentLoader from "react-content-loader";

const TableSkeleton = ({ rows = 10, columns = 5, rowHeight = 30, gap = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex}>
              <ContentLoader
                speed={2}
                width="100%"
                height={rowHeight}
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
              >
                <rect x="0" y="5" rx="4" ry="4" width="100%" height={rowHeight - 10} />
              </ContentLoader>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default TableSkeleton;
